module.exports = __webpack_public_path__ + "static/media/infra-structure.873fb24d.svg";